import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { CSVLink } from 'react-csv'
import { DownloadIcon } from "../../iconshere";



function CsvDownload() {
    const players = [
      { SN: "1", Name: "Task", Description: "Task Description", Type:"T" },
      { SN: "1.1", Name: "Sub task", Description: "Sub task Description", Type:"ST" },
      ]
      
      const headers = [
        {
            label:"SN",key:"SN"
        }, 
        {
          label:"Name",key:"Name"
        },
        {
          label:"Description",key:"Description"
        },
        {
          label:"Type",key:"Type"
        },
      ]
      
      const csvLink = {
        headers: headers,
        data: players,
        filename:"csvfile.csv"
      }


  return (
    <span className=" btn btn-sm csvdownload" style={{  }}>
        <CSVLink {...csvLink}>
         <div className="svg"> <DownloadIcon /> </div>
          <div>CSV</div></CSVLink>
    </span>
  )
}

export default CsvDownload